<template>
  <v-dialog
    v-model="dialog"
    flat
    persistent
    max-width="900"
    content-class="br_none"
  >
    <v-card class="br_none modal_comfirm_wrap type4">
      <v-btn class="modal_close" @click="$emit('close')" fab color="white">
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
      <h2 class="header_title02 type4">{{$t('user.agent.add.title')}}</h2>
    </v-card>
    <v-layout class="login_wrap type2 modal_type">
      <v-flex class="pa-0 login_content type2">
        <v-form
          v-model="valid_add"
          lazy-validation
        >
          <v-card class="login_form type2 type3" flat>
            <v-divider color="#777"></v-divider>
            <perfect-scrollbar class="h650">
              <v-card-text class="pa-0 inner_item_content bd_none">
                <v-row class="ma-0">
                  <v-col cols="12" class="pa-0 mb-45">
                    <v-row class="mb-30">
                      <v-col cols="12" md="6">
                        <h2 class="nec_title mb-15"><i>*</i> {{$t('user.agent.add.fields.email')}}</h2>
                        <v-text-field
                          label=""
                          solo
                          outlined
                          flat
                          dense
                          placeholder=""
                          append-icon="mdi-alert"
                          class="login_text_filed email"
                          v-model="email"
                          v-validate="'required|email'"
                          :error-messages="errors.collect('email')"
                          name="email"
                          :data-vv-as="$t('user.agent.add.fields.email')"
                      ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <h2 class="nec_title mb-15">{{$t('user.agent.add.fields.agent_no')}}</h2>
                        <v-text-field
                          label=""
                          solo
                          outlined
                          flat
                          dense
                          placeholder=""
                          append-icon="mdi-alert"
                          class="login_text_filed"
                          v-model="agent_no"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <h2 class="nec_title mb-15"><i>*</i> {{$t('user.agent.add.fields.name_en')}}</h2>
                        <v-text-field
                          label=""
                          solo
                          outlined
                          flat
                          dense
                          placeholder=""
                          append-icon="mdi-alert"
                          class="login_text_filed"
                          v-model="name_en"
                          v-validate="{required: true}"
                          :error-messages="errors.collect('name_en')"
                          name="name_en"
                          :data-vv-as="$t('user.agent.add.fields.name_en')"
                      ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <h2 class="nec_title mb-15"><i>*</i>{{$t('user.agent.add.fields.name_ar')}}</h2>
                        <v-text-field
                          label=""
                          solo
                          outlined
                          flat
                          dense
                          placeholder=""
                          append-icon="mdi-alert"
                          class="login_text_filed arabic_align"
                          v-model="name_ar"
                          v-validate="{required: true}"
                          :error-messages="errors.collect('name_ar')"
                          name="name_ar"
                          :data-vv-as="$t('user.agent.add.fields.name_ar')"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="pa-0 mb-35">
                    <h2 class="nec_title mb-15"><i>*</i> {{$t('user.agent.add.fields.authorization')}}</h2>
                    <v-radio-group
                      v-model="agent_authorization_type_code"
                    >
                      <v-flex class="radio_bx">
                        <v-label>
                          <v-radio
                            color="#a01c2a"
                            value="2801"
                          ></v-radio>
                          <v-spacer class="hidden_lr2"></v-spacer>
                          <v-icon color="#a01c2a">mdi-lock-open-outline</v-icon>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          {{ $t('user.agent.detail.fields.auth_1') }}
                        </v-label>
                      </v-flex>
                      <v-flex class="radio_bx">
                        <v-label>
                          <v-radio
                            color="#a01c2a"
                            value="2802"
                          ></v-radio>
                          <v-spacer class="hidden_lr2"></v-spacer>
                          <v-icon color="#a01c2a">mdi-eye</v-icon>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          {{ $t('user.agent.detail.fields.auth_2') }}
                        </v-label>
                      </v-flex>
                      <v-flex class="radio_bx">
                        <v-label>
                          <v-radio
                            color="#a01c2a"
                            value="2803"
                          ></v-radio>
                          <v-spacer class="hidden_lr2"></v-spacer>
                          <v-icon color="#a01c2a">mdi-lock</v-icon>
                          <v-spacer class="hidden_lr5"></v-spacer>
                          {{ $t('user.agent.detail.fields.auth_3') }}
                        </v-label>
                      </v-flex>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-card-actions class="pl-0 pr-0 mt-25">
                  <v-spacer></v-spacer>
                  <v-btn class="button-size-1 btn-actv type2" :loading="isActiveBtn" rounded @click="fnAddMember()">{{ $t('common.button.save') }}</v-btn>
                </v-card-actions>
              </v-card-text>
            </perfect-scrollbar>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  components :{
  },
  props: {
    dialog: {
      type: Boolean
    }
  },
  data () {
    return {
      title : '',
      tab : false,
      valid_add : true,
      isActiveBtn : false,

      email : '',
      name_en : '',
      name_ar : '',
      agent_no : '',
      ind_representative : 'N',
      agent_authorization_type_code : '2801'

    }
  },
  mounted(){
  },
  methods: {
    fnAddMember(){
      this.$validator.validateAll().then((result) => {
        if(result){

          let params = {
            email : this.email,
            name_en : this.name_en,
            name_ar : this.name_ar,
            agent_no : this.agent_no,
            ind_representative : this.ind_representative,
            agent_authorization_type_code : this.agent_authorization_type_code
          }

          this.isActiveBtn = true

          requestApi({
            url: '/users/agent/offices/users',
            method: 'POST',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                this.isActiveBtn = false

                let snackBarOptions = {
                  text: this.$t('user.agent.add.fields.success')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                this.$emit('success')
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnAddMember()
                  })
                } else {
                  this.isActiveBtn = false

                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    }
  }
}
</script>